<template>
  <li>
    <Toggle @toggleItem="toggleActivity" v-bind:state="state">
      <div class="text">
        {{ activity.title }}
        <span class="minor" v-html="streak"></span>
      </div>
    </Toggle>
  </li>
</template>

<script>
import {store} from '@/store'
import DataActivities from '@/data/controllers/DataActivities'
import Toggle from '@/components/elements/Toggle'

export default {
  name: 'ActvityToggle',
  props: ['activity'],
  components: {
    'Toggle': Toggle
  },
  data () {
    return {
      checkedProxy: false
    }
  },
  computed: {
    state () {
      let thisDate = store.state.activeDate
      let trackActivities = store.state.trackActivities
      let activeDates = trackActivities.dates
      let activeDateActivities = trackActivities.dates[thisDate]
      if ((thisDate && trackActivities && activeDates && activeDateActivities && (activeDateActivities.includes(this.$props.activity.id) || activeDateActivities.includes(this.$props.activity.id.toString())))) {
        return true
      }
      return false
    },
    localID () {
      return this.$props.activity.id
    },
    streak () {
      let params = {
        activity: this.$props.activity.id,
        date: store.state.activeDate
      }
      let streak = DataActivities.calculateStreak(params)
      if (!streak) {
        return
      }
      if (streak.days > 1) {
        return '<span class="streak end' + streak.streakEnd + '">' + streak.days + ' days</span>'
      } else {
        return '<span class="streak end' + streak.streakEnd + ' streakone">' + streak.days + ' day</span>'
      }
    }
  },
  methods: {
    toggleActivity (state) {
      // let on = this.checkedProxy
      let obj = {
        id: this.$props.activity.id,
        on: state,
        date: store.state.activeDate
      }
      DataActivities.toggleActivity(obj)
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables/variables';
  .streak {
    color: $brandSalmon;
    &.endyesterday {
      color: $brandDarkGray;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/activities/ActivityToggle.vue